export const DELIVERY_COST_DOMESTIC = 14.5
export const DELIVERY_COST_FOREIGN = 19.7
export const DELIVERY_COST_DOMESTIC_WITH_COMMA = '14,50'
export const DELIVERY_COST_FOREIGN_WITH_COMMA = '19,70'
export const DELIVERY_COST_GIFTCARD = 3.8

export const GIFTCARD_ID = 1001
